module.exports = __webpack_public_path__ + "static/media/m_eyeshape_upturned_lightbrown.c71610c0.png";